import {
  TrialStatus,
  SubscriptionCardStatusText,
  SubscriptionStatus as SubscriptionStatuses,
} from '@/constants/constants';

interface SubscriptionStatusProps {
  status: SubscriptionStatuses;
  trialStatus: TrialStatus;
}

function SubscriptionStatus({ status, trialStatus }: SubscriptionStatusProps) {
  const { InTrial } = TrialStatus;
  const { Expired, Cancelling } = SubscriptionStatuses;

  return (
    <>
      {status === Expired && (
        <span
          data-cy='subscription-status'
          className='bg-slate-200 text-slate-700 text-xs font-medium me-2 px-2.5 py-0.5 rounded'
        >
          {SubscriptionCardStatusText.Expired}
        </span>
      )}
      {trialStatus === InTrial && (
        <span
          data-cy='subscription-status'
          className='bg-yellow-200 text-yellow-700 text-xs font-bold me-2 px-2.5 py-0.5 rounded uppercase'
        >
          {SubscriptionCardStatusText.Trialing}
        </span>
      )}
      {status === Cancelling && (
        <span
          data-cy='subscription-status'
          className='bg-red-100 text-red-700 text-xs font-medium me-2 px-2.5 py-0.5 rounded'
        >
          {SubscriptionCardStatusText.Cancelling}
        </span>
      )}
    </>
  );
}

export default SubscriptionStatus;
